import { create } from 'zustand';

import { ApiJobDocument } from '@/shared/api';

export type SmartImportState = {
  jobId: string | null;
  isLoading: boolean;
  data: ApiJobDocument | null;
};

export type SmartImportStore = SmartImportState & {
  setJobId: (jobId: string | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  setData: (data: ApiJobDocument | null) => void;
  clear: () => void;
};

const getInitialState = (): SmartImportState => ({
  jobId: null,
  data: null,
  isLoading: false,
});

export const useSmartImportStore = create<SmartImportStore>((set) => ({
  ...getInitialState(),

  setJobId: (jobId) => set({ jobId }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setData: (data) => set({ data }),
  clear: () => set(getInitialState()),
}));
